import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">DH Stock Progress</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y, Z where, <br />
          X = Sum of all DH max stock for the current unit of selected date
          range (T) <br />
          Y = Sum of all DH max stock for the previous unit of selected date
          range (T-1) <br />Z = Sum of all DH max stock for the unit before last
          one of selected date range (T-2)
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
